import { EmptyUrlResolverParams, RouterResolver } from '@isaia/router';

export const resolveFabricRoutes = (resolver: RouterResolver) => {
  return resolver.createFeatureResolver('fabric', (rootPath) => {
    return {
      list: (options?: EmptyUrlResolverParams) => {
        const url = resolver.createUrlTree([rootPath, 'list'], options);
        return resolver.createUrlNavigableData(url);
      },
    };
  });
};
